import React, { Component } from "react";
import { useState } from "react";
import Swal from "sweetalert2";
import { SideMenu } from "./SideMenu"; // (left as-is; used elsewhere in app)
import CartContext from "./CartContext";
import { BsFillPencilFill } from "react-icons/bs";
import { FaTrashAlt } from "react-icons/fa";
import {
  BiSave,
  BiRefresh,
  BiUpload,
  BiDownload,
  BiBarChart,
} from "react-icons/bi";
import Fuse from "fuse.js";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
import Switch from "react-switch";
import axios from "axios";
import { useZxing } from "react-zxing";
import ProductInventoryDashboard from "./ProductInventoryDashboard";

// import "../CSS/3d.css";
import { IoMdQrScanner } from "react-icons/io";

import {
  Nav,
  Stack,
  InputGroup,
  FormControl,
  Table,
  OverlayTrigger,
  Tooltip,
  Navbar,
  Modal,
  ListGroup,
  FloatingLabel,
} from "react-bootstrap";
import { Button, ButtonToolbar, Form, Row, Col } from "react-bootstrap";

import { ProductAddOrEditModal } from "./ProductAddOrEditModal";

const WAIT_INTERVAL = 1000;

export class Product extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      prods: [],
      rawmaterialwarehouse: [],
      addModalShow: false,
      selectedMainCategoryId: "0",
      selectedSubCategoryId: "0",
      selectedBrandId: "0",
      selectedHideMe: "All",
      filteredProducts: [],
      filteredProductsCopy: [],
      filteredOnHideProductsCopy: [],
      searchquery: "",
      loading: true,
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      firstLoad: false,
      showResultsLimit: 25,
      viewMode: "Basic",
      selectedWarehouseId: "0",
      // 🔽 NEW
      selectedStoreUnitId: "0",
      selectedTankId: "0",

      // lookups
      storageUnits: [],
      tanks: [],
      showDashboard: false,
      sellingPriceRules: [],
    };
    this.inputFile = React.createRef();
  }

  KEYS = ["thickness", "internalId", "name", "remarks", "sku"];
  THICKNESS_EPS = 0.05;

  filterByWarehouse = (list) => {
    const { selectedWarehouseId } = this.state;
    if (!selectedWarehouseId || selectedWarehouseId === "0") return list;
    return list.filter(
      (p) => String(p.warehouseId) === String(selectedWarehouseId),
    );
  };

  deepClone = (obj) =>
    window.structuredClone
      ? structuredClone(obj)
      : JSON.parse(JSON.stringify(obj));

  resetFilteredToCopy = () =>
    this.setState({
      filteredProducts: this.deepClone(this.state.filteredProductsCopy),
    });

  loadStorageUnits = async () => {
    const res = await axios.get(process.env.REACT_APP_API + "StorageUnit", {
      params: { storeId: this.context.storeId },
    });
    this.setState({ storageUnits: res.data });
  };

  searchProducts = (list, q) => {
    const fuse = new Fuse(list, {
      keys: this.KEYS,
      threshold: 0.3,
      ignoreLocation: true,
      distance: 200,
    });

    const matchSet = new Set(fuse.search(q).map((r) => r.item));
    const numQ = Number(q);

    if (!Number.isNaN(numQ)) {
      list.forEach((item) => {
        const t = Number(item?.thickness);
        if (!Number.isNaN(t) && Math.abs(t - numQ) <= this.THICKNESS_EPS) {
          matchSet.add(item);
        } else if (
          String(item?.thickness ?? "")
            .toLowerCase()
            .includes(q.toLowerCase())
        ) {
          matchSet.add(item);
        }
      });
    }
    return Array.from(matchSet);
  };

  _timer = null;
  debounce = (fn, delay) => {
    clearTimeout(this._timer);
    this._timer = setTimeout(fn, delay);
  };
  componentWillUnmount() {
    clearTimeout(this._timer);
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  onFilteredProductsChanged = () =>
    this.setState({
      filteredProductsCopy: this.deepClone(this.state.filteredProducts),
    });

  OnShowResultsLimitChanges = (e) => {
    const { filteredProducts } = this.state;
    const val = e.target.value;
    const limit = val === "All" ? filteredProducts.length : Number(val) || 25;
    this.setState({ showResultsLimit: limit });
  };

  resetOnHideFilter = () =>
    this.setState({ selectedHideMe: "All", filteredOnHideProductsCopy: [] });

  // Category / Brand / Warehouse filters
  onWarehouseSelectChangeEvent = (e) =>
    this.setState(
      {
        selectedWarehouseId: e.target.value,
        selectedStoreUnitId: "0",
        selectedTankId: "0",
        tanks: [],
      },
      this.onCategoryChanges,
    );

  onMainCategorySelectChangeEvent = (e) =>
    this.setState(
      { selectedMainCategoryId: e.target.value, selectedSubCategoryId: "0" },
      this.onCategoryChanges,
    );

  onSubCategorySelectChangeEvent = (e) =>
    this.setState(
      { selectedSubCategoryId: e.target.value },
      this.onCategoryChanges,
    );

  onBrandSelectChangeEvent = (e) => {
    const selectedBrandId = e.target.value;
    if (String(selectedBrandId) === "0") {
      this.setState(
        {
          selectedBrandId,
          selectedMainCategoryId: "0",
          selectedSubCategoryId: "0",
        },
        this.onCategoryChanges,
      );
      return;
    }
    const byBrand = this.context.prods.filter(
      (p) => String(p.brandId) === String(selectedBrandId),
    );
    this.setState(
      {
        selectedBrandId,
        selectedMainCategoryId: "0",
        selectedSubCategoryId: "0",
        filteredProducts: this.deepClone(this.filterByWarehouse(byBrand)),
      },
      this.onFilteredProductsChanged,
    );
  };

  onHideMeSelectChangeEvent = (e) => {
    const selectedHideMe = e.target.value;
    const { filteredOnHideProductsCopy, filteredProducts } = this.state;

    if (selectedHideMe === "All") {
      this.setState(
        { selectedHideMe, filteredOnHideProductsCopy: [] },
        this.onCategoryChanges,
      );
      return;
    }

    const baseline = filteredOnHideProductsCopy.length
      ? filteredOnHideProductsCopy
      : filteredProducts;

    const next = this.filterByWarehouse(
      baseline.filter((f) => String(f.hideMe) === String(selectedHideMe)),
    );

    this.setState(
      {
        selectedHideMe,
        filteredOnHideProductsCopy:
          filteredOnHideProductsCopy.length > 0
            ? filteredOnHideProductsCopy
            : this.deepClone(filteredProducts),
        filteredProducts: this.deepClone(next),
      },
      this.onFilteredProductsChanged,
    );
  };

  OnDeleted = (indexno) => {
    const list = [...this.state.filteredProducts];
    list.splice(indexno, 1);
    this.setState({ filteredProducts: list });
  };

  OnUpdated = async () => {
    await new Promise((r) => setTimeout(r, 500)); // simulate
    this.onCategoryChanges();
  };

  OnRefreshButtonClick = async () => {
    this.ShowLoadSpinner();
    try {
      await this.context.GetAllProducts();
      await new Promise((r) => setTimeout(r, 500)); // simulate
      this.onCategoryChanges();
    } finally {
      this.HideLoadSpinner();
    }
  };

  addModalClose = () => this.setState({ addModalShow: false });

  onSearchChange = (query) => {
    this.setState({ searchquery: query });
    if (!query || !query.trim()) {
      this.resetFilteredToCopy();
      return;
    }
    this.debounce(this.ShowSearchResults, WAIT_INTERVAL);
  };

  ShowSearchResults = () => {
    const { searchquery, filteredProductsCopy } = this.state;
    const q = (searchquery || "").trim();
    if (!q) {
      this.resetFilteredToCopy();
      return;
    }
    const list = [...filteredProductsCopy];
    const results = this.searchProducts(list, q).slice(0, 25);
    this.setState({ filteredProducts: results });
  };

  onCategoryChanges = () => {
    const { selectedMainCategoryId, selectedSubCategoryId } = this.state;
    const sorted = this.deepClone(this.context.prods).sort((a, b) =>
      a.seqNo > b.seqNo ? 1 : -1,
    );

    let filtered;
    if (selectedMainCategoryId === "0" && selectedSubCategoryId === "0") {
      filtered = this.deepClone(this.context.prods);
    } else if (
      selectedMainCategoryId !== "0" &&
      selectedSubCategoryId === "0"
    ) {
      filtered = sorted.filter(
        (p) => p.subCategory.mainCategoryId === selectedMainCategoryId,
      );
    } else {
      filtered = sorted.filter(
        (p) =>
          p.subCategory.mainCategoryId === selectedMainCategoryId &&
          p.subCategory.id === selectedSubCategoryId,
      );
    }
    // filtered = this.filterByWarehouse(filtered);
    filtered = this.filterByLocation(filtered);

    this.setState({ filteredProducts: [] }, () => {
      this.setState(
        { filteredProducts: filtered },
        this.onFilteredProductsChanged,
      );
    });
  };

  async GetRawMaterialWarehouses() {
    try {
      const response = await fetch(
        process.env.REACT_APP_API +
          "Warehouse/GetRawMaterialWarehouses/" +
          this.context.storeId,
      );
      const data = await response.json();
      if (data.status !== 400) {
        this.setState({ rawmaterialwarehouse: data });
      }
    } catch (err) {
      console.error("GetRawMaterialWarehouses error", err);
    }
  }

  async GetSellingPriceRules() {
    try {
      const storeId = this.context?.storeId;
      if (!storeId) return;
      const res = await fetch(
        `${process.env.REACT_APP_API}SellingPriceRules?storeId=${storeId}`,
      );
      if (!res.ok) throw new Error("Failed to load rules");
      const data = await res.json();
      // data is camelCase returned by your API
      this.setState({ sellingPriceRules: data || [] });
    } catch (err) {
      console.error("GetSellingPriceRules error", err);
      // don't block; just keep empty list
      this.setState({ sellingPriceRules: [] });
    }
  }

  async componentDidMount() {
    window.scrollTo(0, 0);
    if (!this.state.firstLoad) {
      await this.context.GetAllProducts();
      this.state.firstLoad = true;
      await this.GetRawMaterialWarehouses();
      await this.GetSellingPriceRules(); // <-- add this
      await new Promise((r) => setTimeout(r, 1000));
      this.setState({ loading: false });
      this.onCategoryChanges();
      await this.loadStorageUnits();
    }
  }

  loadTanksByUnit = async (storeUnitId) => {
    if (!storeUnitId || storeUnitId === "0") {
      this.setState({ tanks: [] });
      return;
    }

    const res = await axios.get(process.env.REACT_APP_API + "Tank", {
      params: {
        storeId: this.context.storeId,
        storageUnitId: storeUnitId,
      },
    });

    this.setState({ tanks: res.data });
  };
  onSectionSelectChange = (e) => {
    const storeUnitId = e.target.value;

    this.setState(
      {
        selectedStoreUnitId: storeUnitId,
        selectedTankId: "0", // reset tank
      },
      () => {
        this.loadTanksByUnit(storeUnitId);
        this.onCategoryChanges();
      },
    );
  };

  onTankSelectChange = (e) => {
    this.setState({ selectedTankId: e.target.value }, this.onCategoryChanges);
  };

  filterByLocation = (list) => {
    const { selectedWarehouseId, selectedStoreUnitId, selectedTankId } =
      this.state;

    let result = list;

    if (selectedWarehouseId && selectedWarehouseId !== "0") {
      result = result.filter(
        (p) => String(p.warehouseId) === String(selectedWarehouseId),
      );
    }

    if (selectedStoreUnitId && selectedStoreUnitId !== "0") {
      result = result.filter(
        (p) => String(p.storeUnitId) === String(selectedStoreUnitId),
      );
    }

    if (selectedTankId && selectedTankId !== "0") {
      result = result.filter(
        (p) => String(p.tankId) === String(selectedTankId),
      );
    }

    return result;
  };

  DownloadProductsToCSV = async () => {
    this.ShowLoadSpinner();
    var apiName =
      this.context.store.businessTypeId ==
      this.context.BusinessTypes.STEELTRADERS
        ? "DownloadProductsToCSVForSharoffSteel"
        : "DownloadProductsToCSV";
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}StoreManager/${apiName}/${this.context.storeId}`,
        { responseType: "blob" },
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const now = new Date();
        link.download = `products-${now
          .toISOString()
          .replace(/[-:T]/g, "")
          .slice(0, 14)}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        this.ShowMessagBox("Error", "Download Failed. Please try later!");
      }
    } catch (err) {
      console.error("DownloadProductsToCSV - error:", err);
      this.ShowMessagBox("Error", "Download Failed. Please try later!");
    } finally {
      this.HideLoadSpinner();
    }
  };

  onUploadButtonClick = () => this.inputFile.current?.click();

  handleFileUpload = (e) => {
    const { files } = e.target;
    if (!files || !files[0]) return;
    this.ShowLoadSpinner();
    const reader = new FileReader();
    reader.onload = (ev) => this.UploadProductsFromCSV(ev.target.result);
    reader.readAsText(files[0]);
  };

  UploadProductsFromCSV = async (csvstr) => {
    this.ShowLoadSpinner();
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}StoreManager/UploadProductsFromCsv/${
          this.context.storeId
        }/${
          this.context.store.businessTypeId ==
          this.context.BusinessTypes.STEELTRADERS
            ? 3
            : 1
        }`,
        {
          method: "POST",
          headers: { "Content-Type": "text/plain" },
          body: csvstr,
        },
      );
      if (!response.ok) throw new Error("Upload failed");
      const data = await response.text();
      this.ShowMessagBox("Information", "Uploaded Successfully!\n\n" + data);
      // Auto refresh products after upload
      this.OnRefreshButtonClick();
    } catch (err) {
      console.error("UploadProductsFromCSV error:", err);
      this.ShowMessagBox("Error", "Failed - Invalid CSV file format");
    } finally {
      this.HideLoadSpinner();
    }
  };

  render() {
    if (this.state.loading) return <LoadSpinner open="true" />;

    const isDesktop = window.innerWidth >= 900;

    return (
      <div className="Container-fluid m-0 p-0 pagebackground border">
        {this.state.msgboxOpen && (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        )}
        {this.state.addModalShow === true ? (
          <ProductAddOrEditModal
            show={this.state.addModalShow}
            Type="Add"
            onHide={this.addModalClose}
            sellingPriceRules={this.state.sellingPriceRules} // <-- added
          />
        ) : null}

        <input
          style={{ display: "none" }}
          accept=".csv"
          ref={this.inputFile}
          onChange={this.handleFileUpload}
          type="file"
        />
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}

        <Modal
          show={this.state.showDashboard}
          onHide={() => this.setState({ showDashboard: false })}
          size="xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Product(FG) Inventory Dashboard</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ProductInventoryDashboard />
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showDashboard: false })}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
          <h3>
            <b>{isDesktop ? "Product Inventory" : "PRD Inventory"}</b>
          </h3>
          <Navbar.Collapse className="justify-content-end mx-1 ">
            <Nav>
              <ButtonToolbar className="text-end align-middle">
                <Button
                  className="mainthemecolor "
                  onClick={() => this.setState({ addModalShow: true })}
                >
                  + Add
                </Button>
                &nbsp;
                <Button
                  className="mainthemecolor "
                  onClick={this.OnRefreshButtonClick}
                >
                  <BiRefresh size="20" /> Refresh
                </Button>
                &nbsp;
                <Button
                  variant="outline-primary"
                  onClick={() => this.setState({ showDashboard: true })}
                >
                  <BiBarChart size={16} /> &nbsp;Analytics
                </Button>
                {isDesktop && (
                  <>
                    &nbsp;
                    <Button
                      variant="outline-secondary"
                      onClick={this.onUploadButtonClick}
                    >
                      <BiUpload size="20" /> Upload CSV
                    </Button>
                    &nbsp;
                    <Button
                      variant="outline-secondary"
                      onClick={this.DownloadProductsToCSV}
                    >
                      <BiDownload size="20" /> Download CSV
                    </Button>
                  </>
                )}
              </ButtonToolbar>
            </Nav>
          </Navbar.Collapse>
        </Navbar>

        {/* Purpose Info */}
        <div className="purposestyle">
          <b>Purpose:</b> Manage Product Inventory ready for POS or ECommerce.
          Products are linked with Main/Sub categories. Contact Sales for bulk
          upload.
        </div>

        <div className="p-2">
          <Row>
            {isDesktop ? (
              // Desktop Filters + Table
              <>
                {/* Filters */}
                <Row className="w-100 border-0 py-2 ">
                  <Col md={4}>
                    <Stack direction="horizontal" gap={3}>
                      <b>🔍</b>
                      <FormControl
                        type="search"
                        placeholder="Search... "
                        className="text-dark fw-bold bg-white "
                        size="lg"
                        onChange={(e) => this.onSearchChange(e.target.value)}
                      />
                    </Stack>
                  </Col>
                  <Col md={1}>
                    <FloatingLabel label="Warehouse">
                      <Form.Select
                        value={this.state.selectedWarehouseId}
                        onChange={this.onWarehouseSelectChangeEvent}
                      >
                        <option value="0">--All WH--</option>
                        {this.state.rawmaterialwarehouse.map((wh) => (
                          <option key={wh.id} value={wh.id}>
                            {wh.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={1}>
                    <FloatingLabel label="Section">
                      <Form.Select
                        value={this.state.selectedStoreUnitId}
                        onChange={this.onSectionSelectChange}
                      >
                        <option value="0">--All--</option>
                        {this.state.storageUnits.map((u) => (
                          <option key={u.id} value={u.id}>
                            {u.unitName}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col md={1}>
                    <FloatingLabel label="Tank">
                      <Form.Select
                        value={this.state.selectedTankId}
                        onChange={this.onTankSelectChange}
                        disabled={this.state.selectedStoreUnitId === "0"}
                      >
                        <option value="0">--All--</option>
                        {this.state.tanks.map((t) => (
                          <option key={t.id} value={t.id}>
                            {t.tankCode}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Main Category">
                      <Form.Select
                        value={this.state.selectedMainCategoryId}
                        disabled={this.state.selectedBrandId !== "0"}
                        onChange={this.onMainCategorySelectChangeEvent}
                      >
                        <option value="0">--All--</option>
                        {this.context.mainCategories.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.name}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={1}>
                    <FloatingLabel label="SubCategory">
                      <Form.Select
                        value={this.state.selectedSubCategoryId}
                        disabled={this.state.selectedBrandId !== "0"}
                        onChange={this.onSubCategorySelectChangeEvent}
                      >
                        <option value="0">--All--</option>
                        {this.context.subCategories
                          .filter(
                            (s) =>
                              s.mainCategoryId ===
                              this.state.selectedMainCategoryId,
                          )
                          .map((s) => (
                            <option key={s.id} value={s.id}>
                              {s.name}
                            </option>
                          ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={1}>
                    <FloatingLabel label="Brand">
                      <Form.Select
                        value={this.state.selectedBrandId}
                        onChange={this.onBrandSelectChangeEvent}
                      >
                        <option value="0">--All--</option>
                        {this.context.brands
                          .sort((a, b) => (a.brandName > b.brandName ? 1 : -1))
                          .map((b) => (
                            <option key={b.id} value={b.id}>
                              {b.brandName}
                            </option>
                          ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={1}>
                    <FloatingLabel label="Show Me">
                      <Form.Select
                        value={this.state.selectedHideMe}
                        onChange={this.onHideMeSelectChangeEvent}
                      >
                        <option value="All">All</option>
                        <option value={false}>True</option>
                        <option value={true}>False</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={1}>
                    <FloatingLabel label="View Mode">
                      <Form.Select
                        onChange={(e) =>
                          this.setState({ viewMode: e.target.value })
                        }
                      >
                        <option value="Basic">Basic</option>
                        <option value="Advanced">Advanced</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={1}>
                    <FloatingLabel label="Show Results">
                      <Form.Select onChange={this.OnShowResultsLimitChanges}>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="All">All</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                </Row>

                {/* Product Table */}
                <div
                  id="scrollableDiv"
                  className="bg-white overflow-scroll"
                  style={{ height: window.innerHeight - 150 + "px" }}
                >
                  {this.context.store.businessTypeId !==
                  this.context.BusinessTypes.STEELTRADERS ? (
                    <Table hover striped className="px-0 bg-white">
                      <thead>
                        <tr
                          className="text-center text-black bg-white border"
                          style={{ fontSize: "12px" }}
                        >
                          <th width="1%"></th>
                          <th width="3%"></th>
                          <th width="15%" className="text-start">
                            Product Name
                          </th>
                          <th width="10%">Codes</th>
                          <th width="7%">WH</th>
                          <th width="5%">Show-Me</th>
                          <th width="6%">P.Price</th>
                          <th width="7%">MRP</th>
                          <th width="7%">WS MRP</th>
                          <th width="7%">SWS MRP</th>
                          <th width="5%">GST</th>
                          <th width="7%">Sell Price Rule</th>
                          <th width="5%">Disc(%)</th>
                          <th width="8%">S.Price/unit</th>
                          <th width="6%">InStk</th>
                          <th width="5%">Options</th>
                        </tr>
                      </thead>
                      <tbody className="text-primary border mb-lg-5">
                        {this.state.filteredProducts.length === 0 ? (
                          <tr>
                            <td colSpan="12" className="text-center text-muted">
                              No products found
                            </td>
                          </tr>
                        ) : (
                          this.state.filteredProducts
                            .slice(0, this.state.showResultsLimit)
                            .map((prod, i) => (
                              <EditProductInline
                                key={prod.id || i}
                                index={i}
                                prod={prod}
                                OnDeleted={this.OnDeleted}
                                OnUpdated={this.OnUpdated}
                                viewMode={this.state.viewMode}
                                rawmaterialwarehouse={
                                  this.state.rawmaterialwarehouse
                                }
                                sellingPriceRules={this.state.sellingPriceRules} // <-- added
                              />
                            ))
                        )}
                      </tbody>
                    </Table>
                  ) : (
                    <Table striped hover size="sm" className="px-0 bg-white">
                      <thead>
                        <tr className="text-center text-black bg-white border">
                          <th></th>
                          <th width="15%" className="text-start">
                            Name
                          </th>
                          {this.context.store.businessTypeId ==
                          this.context.BusinessTypes.STEELTRADERS ? (
                            <>
                              <th width="5%" className="text-start">
                                Thick
                              </th>
                              <th width="5%" className="text-start">
                                Width
                              </th>
                              <th width="5%" className="text-start">
                                Length
                              </th>{" "}
                              <th width="10%" className="text-start">
                                Remarks
                              </th>{" "}
                            </>
                          ) : (
                            <></>
                          )}
                          <th width="5%">
                            {this.context.store.businessTypeId ==
                            this.context.BusinessTypes.STEELTRADERS
                              ? "SCNo"
                              : "Int.ID"}
                          </th>
                          <th width="6%">
                            {this.context.store.businessTypeId ==
                            this.context.BusinessTypes.STEELTRADERS
                              ? "CoilId"
                              : "BatchId"}
                          </th>
                          <th width="6%">HSN</th>
                          <th width="6%">
                            {this.context.store.businessTypeId ==
                            this.context.BusinessTypes.STEELTRADERS
                              ? "TR-NO"
                              : "Quality No"}
                          </th>
                          <th width="7%">Cate</th>
                          <th width="7%">WH</th>
                          {this.context.store.businessTypeId ==
                            this.context.BusinessTypes.STEELTRADERS && (
                            <>
                              <th width="4%">PC InStk</th>
                              <th width="6%">LocalWt</th>
                              <th width="6%">Wt InStk </th>
                            </>
                          )}
                          {this.context.store.businessTypeId !=
                            this.context.BusinessTypes.STEELTRADERS && (
                            <>
                              <th width="6%">Qty InStk </th>
                            </>
                          )}
                          <th width="6%">Unit</th>
                          <th width="6%">P.Cost / Unit</th>
                          <th width="6%">Value</th>
                          <th width="10%">Options</th>
                        </tr>
                      </thead>
                      <tbody className="text-primary border mb-lg-5">
                        {this.state.filteredProducts.length === 0 ? (
                          <tr>
                            <td colSpan="12" className="text-center text-muted">
                              No products found
                            </td>
                          </tr>
                        ) : (
                          this.state.filteredProducts
                            .slice(0, this.state.showResultsLimit)
                            .map((prod, i) => (
                              <EditProductInline
                                key={prod.id || i}
                                index={i}
                                prod={prod}
                                OnDeleted={this.OnDeleted}
                                OnUpdated={this.OnUpdated}
                                viewMode={this.state.viewMode}
                                rawmaterialwarehouse={
                                  this.state.rawmaterialwarehouse
                                }
                                sellingPriceRules={this.state.sellingPriceRules} // <-- added
                              />
                            ))
                        )}
                      </tbody>
                    </Table>
                  )}
                </div>
              </>
            ) : (
              // ================= Mobile View ==================
              <Col xs={12} className="py-1">
                <div className="my-2 p-1">
                  {/* Filters */}
                  <h5 className="text-center">Filters</h5>
                  <Table size="sm" bordered className="bg-light">
                    <tbody>
                      <tr>
                        <td>Warehouse</td>
                        <td>
                          <Form.Select
                            value={this.state.selectedWarehouseId}
                            onChange={this.onWarehouseSelectChangeEvent}
                          >
                            <option value="0">All</option>
                            {this.state.rawmaterialwarehouse.map((wh) => (
                              <option key={wh.id} value={wh.id}>
                                {wh.name}
                              </option>
                            ))}
                          </Form.Select>
                        </td>
                      </tr>
                      <tr>
                        <td>MainCategory</td>
                        <td>
                          <Form.Select
                            value={this.state.selectedMainCategoryId}
                            disabled={this.state.selectedBrandId !== "0"}
                            onChange={this.onMainCategorySelectChangeEvent}
                          >
                            <option value="0">All</option>
                            {this.context.mainCategories.map((c) => (
                              <option key={c.id} value={c.id}>
                                {c.name}
                              </option>
                            ))}
                          </Form.Select>
                        </td>
                      </tr>
                      <tr>
                        <td>SubCategory</td>
                        <td>
                          <Form.Select
                            value={this.state.selectedSubCategoryId}
                            disabled={this.state.selectedBrandId !== "0"}
                            onChange={this.onSubCategorySelectChangeEvent}
                          >
                            <option value="0">All</option>
                            {this.context.subCategories
                              .filter(
                                (s) =>
                                  s.mainCategoryId ===
                                  this.state.selectedMainCategoryId,
                              )
                              .map((s) => (
                                <option key={s.id} value={s.id}>
                                  {s.name}
                                </option>
                              ))}
                          </Form.Select>
                        </td>
                      </tr>
                      {this.context.brands.length > 0 && (
                        <tr>
                          <td>Brand</td>
                          <td>
                            <Form.Select
                              value={this.state.selectedBrandId}
                              onChange={this.onBrandSelectChangeEvent}
                            >
                              <option value="0">All</option>
                              {this.context.brands
                                .sort((a, b) =>
                                  a.brandName > b.brandName ? 1 : -1,
                                )
                                .map((b) => (
                                  <option key={b.id} value={b.id}>
                                    {b.brandName}
                                  </option>
                                ))}
                            </Form.Select>
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td>HideMe</td>
                        <td>
                          <Form.Select
                            value={this.state.selectedHideMe}
                            onChange={this.onHideMeSelectChangeEvent}
                          >
                            <option value="All">All</option>
                            <option value={false}>False</option>
                            <option value={true}>True</option>
                          </Form.Select>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                {/* Search + limit */}
                <div className="my-2 p-1">
                  <Stack direction="horizontal" gap={2}>
                    <FormControl
                      type="search"
                      placeholder="Search..."
                      className="text-dark fw-bold bg-white"
                      size="sm"
                      onChange={(e) => this.onSearchChange(e.target.value)}
                    />
                    <Form.Select
                      size="sm"
                      className="w-25"
                      onChange={this.OnShowResultsLimitChanges}
                    >
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                      <option value="All">All</option>
                    </Form.Select>
                  </Stack>
                </div>

                {/* Mobile Table */}
                <Table
                  striped
                  className="px-0 bg-white"
                  style={{ tableLayout: "fixed" }}
                >
                  <tbody className="text-primary border">
                    {this.state.filteredProducts.length === 0 ? (
                      <tr>
                        <td className="text-center text-muted">
                          No products found
                        </td>
                      </tr>
                    ) : (
                      this.state.filteredProducts
                        .slice(0, this.state.showResultsLimit)
                        .map((prod, i) => (
                          <EditProductInline
                            key={prod.id || i}
                            index={i}
                            prod={prod}
                            OnDeleted={this.OnDeleted}
                            OnUpdated={this.OnUpdated}
                            rawmaterialwarehouse={
                              this.state.rawmaterialwarehouse
                            }
                            sellingPriceRules={this.state.sellingPriceRules} // <-- added
                          />
                        ))
                    )}
                  </tbody>
                </Table>
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  }
}

export class EditProductInline extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      prod: this.props.prod,
      // 🔽 ADDED
      storageUnits: [],
      tanks: [],
      partitions: [],

      editModalShow: false,
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      onscan: false,
    };
  }

  async componentDidMount() {
    await this.loadStorageUnits();

    const { storeUnitId, tankId } = this.state.prod;

    if (storeUnitId) {
      await this.loadTanks(storeUnitId);
    }

    if (tankId) {
      await this.loadPartitions(tankId);
    }
  }

  /**
   * Generic vertical navigation for inputs sharing the same `name`.
   * Usage: attach as onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
   *
   * Behavior:
   * - Handles ArrowUp / ArrowDown only.
   * - Finds all visible, enabled elements with the same name in document order.
   * - Moves focus to previous/next element. Does NOT modify values.
   */
  handleVerticalFieldNavigation = (e) => {
    const key = e.key;
    if (key !== "ArrowUp" && key !== "ArrowDown") return;

    // Prevent default caret movement / scrolling
    e.preventDefault();

    try {
      // name of the field to navigate (must be present on the target element)
      const fieldName = e.target && e.target.name;
      if (!fieldName) return;

      // Query all elements with the same name (inputs, textareas, selects)
      const selector = `input[name="${fieldName}"], textarea[name="${fieldName}"], select[name="${fieldName}"]`;
      const all = Array.from(document.querySelectorAll(selector)).filter(
        (el) => {
          // only visible, enabled elements
          if (!(el instanceof HTMLElement)) return false;
          if (el.disabled) return false;
          const style = window.getComputedStyle(el);
          if (style.display === "none" || style.visibility === "hidden")
            return false;
          const rect = el.getBoundingClientRect();
          if (rect.width === 0 && rect.height === 0) return false;
          return true;
        },
      );

      if (!all.length) return;

      // find current index
      const active = document.activeElement;
      let idx = all.findIndex((el) => el === active);

      // fallback: if active not found, try using event target reference
      if (idx === -1 && e.target) idx = all.findIndex((el) => el === e.target);

      if (idx === -1) return;

      const targetIndex =
        key === "ArrowUp"
          ? Math.max(0, idx - 1)
          : Math.min(all.length - 1, idx + 1);
      if (targetIndex === idx) return;

      const target = all[targetIndex];
      target.focus();

      // put caret at end for text/number inputs so user can type immediately
      if ("setSelectionRange" in target && typeof target.value === "string") {
        try {
          const len = target.value.length;
          target.setSelectionRange(len, len);
        } catch (e) {
          // ignore for unsupported input types
        }
      }
    } catch (err) {
      // swallow errors so we don't break the UI
      // console.debug("vertical nav error", err);
    }
  };

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });
  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });

  handleHidemeChange = (checked) => {
    const prod = {
      ...this.state.prod,
      hideMe: checked === false ? true : false,
    };
    this.setState({ prod });
  };
  handleShowInPosChange = (checked) => {
    const prod = { ...this.state.prod, showePos: checked === true };
    this.setState({ prod });
  };
  handleShowInKioskChange = (checked) => {
    const prod = { ...this.state.prod, showKiosk: checked === true };
    this.setState({ prod });
  };

  loadStorageUnits = async () => {
    const res = await axios.get(process.env.REACT_APP_API + "StorageUnit", {
      params: { storeId: this.context.storeId },
    });
    this.setState({ storageUnits: res.data });
  };

  loadTanks = async (storeUnitId) => {
    if (!storeUnitId) {
      this.setState({ tanks: [], partitions: [] });
      return;
    }

    const res = await axios.get(process.env.REACT_APP_API + "Tank", {
      params: {
        storeId: this.context.storeId,
        storageUnitId: storeUnitId,
      },
    });

    this.setState({ tanks: res.data });
  };

  loadPartitions = async (tankId) => {
    if (!tankId) {
      this.setState({ partitions: [] });
      return;
    }

    const res = await axios.get(process.env.REACT_APP_API + "TankPartition", {
      params: {
        storeId: this.context.storeId,
        tankId,
      },
    });

    this.setState({ partitions: res.data });
  };

  generateUniqueSKU = () => {
    const existingSkus = new Set(
      (this.context.prods || [])
        .map((p) => (p.sku || "").toString())
        .filter(Boolean),
    );

    let sku = "";
    let attempts = 0;

    while (attempts < 1000) {
      sku = Math.floor(10000 + Math.random() * 90000).toString(); // 5-digit
      if (!existingSkus.has(sku)) break;
      attempts++;
    }

    if (existingSkus.has(sku)) {
      alert("Unable to generate unique SKU. Please enter manually.");
      return;
    }

    // ✅ THIS is the missing part
    this.setState((prev) => ({
      prod: {
        ...prev.prod,
        sku: sku,
      },
    }));
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    const prod = { ...this.state.prod };

    switch (name.trim()) {
      case "warehouseId":
        prod.warehouseId = value;
        break;
      case "storeUnitId":
        prod.storeUnitId = value || "";
        this.setState({ prod }, () => this.loadTanks(value));
        return;

      case "tankId":
        prod.tankId = value || "";
        this.setState({ prod }, () => this.loadPartitions(value));
        return;

      case "partitionId":
        prod.partitionId = value || "";
        break;
      case "brandId":
        prod.brandId = value;
        break;
      case "name":
        prod.name = value;
        break;
      case "thickness":
        prod.thickness = value;
        break;
      case "width":
        prod.width = value;
        break;
      case "length":
        prod.length = value;
        break;
      case "remarks":
        prod.remarks = value;
        break;
      case "name2":
        prod.name2 = value;
        break;
      case "sku":
        prod.sku = value;
        break;
      case "internalId":
        prod.internalId = value.replace(/\s/g, "");
        break;
      case "hsncode":
        prod.hsncode = value.replace(/\s/g, "");
        break;
      case "batchId":
        prod.batchId = value.replace(/\s/g, "");
        break;
      case "qualityId":
        prod.qualityId = value.replace(/\s/g, "");
        break;
      case "unit":
        prod.unit = value;
        break;
      case "hideMe":
        prod.hideMe = value;
        break;
      case "purchasePrice":
        prod.purchasePrice = value.trim();
        break;
      case "mrp":
        prod.mrp = value.trim();
        break;
      case "mrpWholeSale":
        prod.mrpWholeSale = value.trim();
        break;

      case "mrpSuperWholeSale":
        prod.mrpSuperWholeSale = value.trim();
        break;
      case "gst":
        prod.gst = value.trim();
        break;
      case "sellingPriceBusinessRuleId":
        prod.sellingPriceBusinessRuleId = !value ? null : value;
        break;
      case "discount":
        prod.discount = value.trim();
        break;
      case "pieceCount":
        prod.pieceCount = value.trim();
        break;
      case "localWt":
        prod.localWt = value.trim();
        break;
      case "inStockQty":
        prod.inStockQty = value.trim();
        break;
      case "takeAwayChargeInPercentage":
        prod.takeAwayChargeInPercentage = value;
        break;
      case "homeDeliveryChargeInPercentage":
        prod.homeDeliveryChargeInPercentage = value;
        break;
      case "seqNo":
        prod.seqNo = value.trim();
        break;
      case "shortAd":
        prod.shortAd = value;
        break;
      default:
        break;
    }
    this.setState({ prod });
  };

  OnDelete = () => {
    this.ShowLoadSpinner();
    const requestOptions = {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    };

    fetch(
      process.env.REACT_APP_API +
        "StoreManager/DeleteProduct/" +
        this.state.prod.id,
      requestOptions,
    )
      .then((res) => {
        if (res.status != 200) {
          this.HideLoadSpinner();
          this.ShowMessagBox("Error", "Delete Failed! try after sometime");
          return;
        }
        this.context.DeleteProductFromMemory(this.state.prod.id);
        this.HideLoadSpinner();
        this.props.OnDeleted(this.props.index);
      })
      .catch(() => {
        this.HideLoadSpinner();
        this.ShowMessagBox("Error", "Delete Failed! try after sometime");
      });
  };

  OnSave = () => {
    const p = this.state.prod;

    // normalize the payload
    const payload = {
      ...p,
      // coerce GUID-like fields: null if empty/"0"
      brandId: !p.brandId || p.brandId === "0" ? null : p.brandId,
      warehouseId:
        !p.warehouseId || p.warehouseId === "0" ? null : p.warehouseId,
      sellingPriceBusinessRuleId:
        !p.sellingPriceBusinessRuleId || p.sellingPriceBusinessRuleId === ""
          ? null
          : p.sellingPriceBusinessRuleId,

      // coerce numerics (avoid "", NaN)
      mrp: p.mrp == null || p.mrp === "" ? 0 : Number(p.mrp),
      mrpWholeSale:
        p.mrpWholeSale == null || p.mrpWholeSale === ""
          ? null
          : Number(p.mrpWholeSale),

      mrpSuperWholeSale:
        p.mrpSuperWholeSale == null || p.mrpSuperWholeSale === ""
          ? null
          : Number(p.mrpSuperWholeSale),
      discount:
        p.discount == null || p.discount === "" ? 0 : Number(p.discount),
      inStockQty:
        p.inStockQty == null || p.inStockQty === "" ? 0 : Number(p.inStockQty),
      seqNo: p.seqNo == null || p.seqNo === "" ? 0 : Number(p.seqNo),

      // (optional) coerce other numerics you use:
      thickness:
        p.thickness == null || p.thickness === "" ? null : Number(p.thickness),
      width: p.width == null || p.width === "" ? null : Number(p.width),
      length: p.length == null || p.length === "" ? null : Number(p.length),
      purchasePrice:
        p.purchasePrice == null || p.purchasePrice === ""
          ? null
          : Number(p.purchasePrice),

      // clean strings (IDs that should have no spaces)
      internalId: (p.internalId || "").replace(/\s/g, ""),
      hsncode: (p.hsncode || "").replace(/\s/g, ""),
      batchId: (p.batchId || "").replace(/\s/g, ""),
      qualityId: (p.qualityId || "").replace(/\s/g, ""),
      storeUnitId:
        !p.storeUnitId || p.storeUnitId === "" ? null : p.storeUnitId,

      tankId: !p.tankId || p.tankId === "" ? null : p.tankId,

      partitionId:
        !p.partitionId || p.partitionId === "" ? null : p.partitionId,
    };

    axios
      .put(
        process.env.REACT_APP_API + "StoreManager/UpdateProduct/" + p.id,
        payload,
        { headers: { "Content-Type": "application/json" } },
      )
      .then((res) => {
        if (res.status === 200) {
          // reflect saved product in context using the same normalized payload
          this.context.UpdateProductInContext(payload);
          Swal.fire({ title: "Saved Successfully!", timer: 500 }).then(() =>
            this.setState({ searchquery: "" }),
          );
          return;
        }
        this.ShowMessagBox("Error", "Saved Failed!");
      })
      .catch((error) => this.ShowMessagBox("Error", "Saved Failed! " + error));
  };

  OnEditButtonClick = () => this.setState({ editModalShow: true });
  editModalClose = () =>
    this.setState({ editModalShow: false }, this.props.OnUpdated);

  getMainCategoryId = (subCategoryId) => {
    const f = this.context.subCategories.filter((e) => e.id === subCategoryId);
    return f.length === 1 ? f[0].mainCategoryId : 0;
  };

  GetBarCode = (value) => {
    const prod = { ...this.state.prod, sku: value };
    this.setState({ prod });
    if (value !== "") this.setState({ onscan: false });
  };
  OnScanner = () => this.setState({ onscan: true });
  OnScannerClose = () => this.setState({ onscan: false });

  render() {
    return (
      <>
        {this.state.editModalShow ? (
          <ProductAddOrEditModal
            show={this.state.editModalShow}
            onHide={this.editModalClose}
            prod={this.state.prod}
            Type="Edit"
            mainCategoryId={this.getMainCategoryId(
              this.state.prod.subCategoryId,
            )}
            sellingPriceRules={this.props.sellingPriceRules} // <-- added
          />
        ) : null}

        {this.state.msgboxOpen ? (
          <MessageBox
            open={this.state.msgboxOpen}
            title={this.state.msgboxTitle}
            message={this.state.msgboxMessage}
            callback={this.CloseMessagBoxCallback}
          />
        ) : null}

        {this.state.loadSpinnerOpen ? <LoadSpinner open="true" /> : null}

        {window.innerWidth >= 900 ? (
          <>
            <tr
              className="text-center align-top text-secondary bg-white mx-5"
              style={{ fontSize: "12px" }}
            >
              <td>{this.props.index + 1}</td>
              <td className="text-center ">
                {this.state.prod.productImages.length > 0 ? (
                  <img
                    src={
                      this.context.store.storageBlobUrl +
                      this.context.store.storageBlobContainerName +
                      "/images/" +
                      this.state.prod.productImages[0].fileName +
                      this.context.store.storageSasToken
                    }
                    className=" rounded-circle"
                    alt="..."
                    width="50px"
                  />
                ) : null}
              </td>
              <td className="text-start">
                <Form.Control
                  type="text"
                  name="name"
                  maxLength={119}
                  value={this.state.prod.name}
                  required
                  className="fw-bold"
                  placeholder="Enter product name in English"
                  autoComplete="off"
                  onChange={this.handleInputChange}
                />
                {this.props.viewMode === "Advanced" ? (
                  <FloatingLabel
                    label="Product Name (in 2nd Language/Unicode)"
                    className="mb-1"
                  >
                    <Form.Control
                      as="textarea"
                      name="name2"
                      rows={2}
                      maxLength={119}
                      value={this.state.prod.name2}
                      placeholder="Enter product name in 2nd language"
                      autoComplete="off"
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel>
                ) : null}
                <Row className="w-100 my-1">
                  <Col xs={12}>
                    <b>Sub Category:</b> {this.state.prod.subCategory.name}
                  </Col>
                </Row>
                {this.props.viewMode === "Advanced" ? (
                  <FloatingLabel label="Brand Name" className="mb-1">
                    <Form.Select
                      name="brandId"
                      size="sm"
                      value={this.state.prod.brandId}
                      onChange={this.handleInputChange}
                    >
                      <option value={0}></option>
                      {this.context.brands
                        .sort((a, b) => (a.brandName > b.brandName ? 1 : -1))
                        .map((brand) => (
                          <option key={brand.id} value={brand.id}>
                            {brand.brandName}
                          </option>
                        ))}
                    </Form.Select>
                  </FloatingLabel>
                ) : null}
              </td>
              <td>
                {/* <FloatingLabel label="SKU">
                    <Form.Control
                      type="text"
                      name="sku"
                      className="text-center"
                      value={this.state.prod.sku}
                      required
                      placeholder="enter SKU"
                      min={0}
                      maxLength={20}
                      autoComplete="off"
                      onChange={this.handleInputChange}
                    />
                  </FloatingLabel> */}

                <InputGroup size="sm">
                  <Form.Control
                    type="text"
                    name="sku"
                    height={20}
                    className="text-center"
                    maxLength={20}
                    size="lg"
                    default="sku"
                    value={this.state.prod.sku || "SKU"}
                    autoComplete="off"
                    onChange={this.handleInputChange}
                  />

                  <Button
                    variant="outline-secondary"
                    title="Auto-generate SKU"
                    onClick={this.generateUniqueSKU}
                    style={{ minWidth: "36px" }}
                  >
                    ⚡
                  </Button>
                </InputGroup>

                <FloatingLabel label="HSNCode" className="mb-1">
                  <Form.Control
                    type="text"
                    name="hsncode"
                    maxLength={40}
                    value={this.state.prod.hsncode}
                    autoComplete="off"
                    onChange={this.handleInputChange}
                  />
                </FloatingLabel>
                {this.props.viewMode === "Advanced" ? (
                  <>
                    <FloatingLabel label="BatchID" className="mb-1">
                      <Form.Control
                        type="text"
                        name="batchId"
                        maxLength={40}
                        value={this.state.prod.batchId}
                        autoComplete="off"
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                    <FloatingLabel label="QualityNo" className="mb-1">
                      <Form.Control
                        type="text"
                        name="qualityId"
                        maxLength={40}
                        value={this.state.prod.qualityId}
                        autoComplete="off"
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </>
                ) : null}
              </td>

              <td className="text-center ">
                <Form.Select
                  name="warehouseId"
                  value={this.state.prod.warehouseId}
                  align="center"
                  className="text-start "
                  autoComplete="off"
                  onChange={this.handleInputChange}
                >
                  <option value={""}>WH</option>
                  {this.props.rawmaterialwarehouse.map((m) => (
                    <option key={m.id} value={m.id}>
                      {m.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Select
                  name="storeUnitId"
                  value={this.state.prod.storeUnitId || ""}
                  className="text-start"
                  onChange={this.handleInputChange}
                >
                  <option value="">Section</option>
                  {this.state.storageUnits.map((u) => (
                    <option key={u.id} value={u.id}>
                      {u.unitName}
                    </option>
                  ))}
                </Form.Select>
                <Form.Select
                  name="tankId"
                  value={this.state.prod.tankId || ""}
                  className="text-start"
                  disabled={!this.state.prod.storeUnitId}
                  onChange={this.handleInputChange}
                >
                  <option value="">
                    {this.context.store.businessTypeId === 18
                      ? "Tank"
                      : "Aisle"}
                  </option>
                  {this.state.tanks.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.tankCode}
                    </option>
                  ))}
                </Form.Select>
                <Form.Select
                  name="partitionId"
                  value={this.state.prod.partitionId || ""}
                  className="text-start"
                  disabled={!this.state.prod.tankId}
                  onChange={this.handleInputChange}
                >
                  <option value="">
                    {this.context.store.businessTypeId === 18
                      ? "Tank Partition"
                      : "Bin"}
                  </option>
                  {this.state.partitions.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.partitionCode}
                    </option>
                  ))}
                </Form.Select>
              </td>
              <td>
                {this.context.storeSettings.showEcommerceModule === true ||
                this.context.storeSettings.showEcommerceModule === undefined ? (
                  <tr className="text-center aligncenerintd1">
                    <td>ECom</td>
                    <td>
                      <Switch
                        height={20}
                        onChange={this.handleHidemeChange}
                        checked={!this.state.prod.hideMe}
                      />
                    </td>
                  </tr>
                ) : null}
                <tr className="text-center aligncenerintd1">
                  <td>POS</td>
                  <td>
                    <Switch
                      height={20}
                      onChange={this.handleShowInPosChange}
                      checked={this.state.prod.showePos}
                    />
                  </td>
                </tr>
                {this.props.viewMode === "Advanced" ? (
                  this.context.storeSettings.showKioskModule === true ||
                  this.context.storeSettings.showKioskModule === undefined ? (
                    <tr className="text-center aligncenerintd1">
                      <td>Kiosk</td>
                      <td>
                        <Switch
                          height={20}
                          onChange={this.handleShowInKioskChange}
                          checked={this.state.prod.showKiosk}
                        />
                      </td>
                    </tr>
                  ) : null
                ) : null}
                {this.props.viewMode === "Advanced" ? (
                  <>
                    <FloatingLabel label="Seq.No" className="mb-1">
                      <Form.Control
                        name="seqNo"
                        value={this.state.prod.seqNo}
                        required
                        min={0}
                        className="text-center text-danger fw-bold"
                        placeholder=""
                        autoComplete="off"
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                    <FloatingLabel label="Short-Ad" className="mb-1">
                      <Form.Control
                        type="text"
                        name="shortAd"
                        value={this.state.prod.shortAd}
                        required
                        maxLength={21}
                        className="text-center text-danger fw-bold"
                        placeholder=""
                        autoComplete="off"
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </>
                ) : null}
              </td>

              <td className="text-center ">
                {this.state.prod.productVariantType != 2 ? (
                  <Form.Control
                    type="text"
                    name="purchasePrice"
                    size="lg"
                    value={this.state.prod.purchasePrice}
                    required
                    style={{ fontSize: "16px" }}
                    placeholder=""
                    className="text-center w-100"
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
                  />
                ) : null}
              </td>
              <td>
                {this.state.prod.productVariantType != 2 ? (
                  <Form.Control
                    type="text"
                    name="mrp"
                    size="lg"
                    value={this.state.prod.mrp}
                    required
                    style={{ fontSize: "16px" }}
                    placeholder=""
                    className="text-center w-100"
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
                  />
                ) : null}
              </td>
              <td>
                <Form.Control
                  type="text"
                  name="mrpWholeSale"
                  size="lg"
                  value={this.state.prod.mrpWholeSale || ""}
                  style={{ fontSize: "16px" }}
                  className="text-center w-100"
                  autoComplete="off"
                  onChange={this.handleInputChange}
                  onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
                />
              </td>

              <td>
                <Form.Control
                  type="text"
                  name="mrpSuperWholeSale"
                  size="lg"
                  value={this.state.prod.mrpSuperWholeSale || ""}
                  style={{ fontSize: "16px" }}
                  className="text-center w-100"
                  autoComplete="off"
                  onChange={this.handleInputChange}
                  onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
                />
              </td>
              <td>
                {this.state.prod.productVariantType != 2 ? (
                  <Form.Control
                    type="text"
                    name="gst"
                    size="lg"
                    value={this.state.prod.gst}
                    required
                    style={{ fontSize: "16px" }}
                    placeholder=""
                    className="text-center w-100"
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
                  />
                ) : null}
              </td>
              <td>
                <Form.Select
                  name="sellingPriceBusinessRuleId"
                  value={this.state.prod.sellingPriceBusinessRuleId ?? ""}
                  align="center"
                  className="text-start "
                  autoComplete="off"
                  onChange={this.handleInputChange}
                >
                  <option value={""}>-- None --</option>

                  {this.props.sellingPriceRules.map((r) => (
                    <option
                      key={r.sellingPriceBusinessRuleId}
                      value={r.sellingPriceBusinessRuleId}
                    >
                      {r.name} {r.isActive ? "" : "(inactive)"}
                    </option>
                  ))}
                </Form.Select>
              </td>
              <td>
                {this.state.prod.productVariantType != 2 ? (
                  <Form.Control
                    type="text"
                    name="discount"
                    size="lg"
                    value={this.state.prod.discount}
                    required
                    hidden={
                      this.state.prod.sellingPriceBusinessRuleId ? true : false
                    }
                    style={{ fontSize: "16px" }}
                    placeholder=""
                    min={0}
                    className="text-center w-100"
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
                  />
                ) : null}
              </td>
              <td>
                {this.state.prod.productVariantType != 2 ? (
                  <span
                    className="text-dark text-center verticalaligncentertd"
                    style={{ fontSize: "18px", fontWeight: "bold" }}
                    hidden={
                      this.state.prod.sellingPriceBusinessRuleId ? true : false
                    }
                  >
                    {this.context
                      .GetBasePrice(this.state.prod)
                      .toLocaleString(
                        this.context.storeSettings == ""
                          ? "en-IN"
                          : this.context.storeSettings.defaultLocale,
                        {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                          style: "currency",
                          currency:
                            this.context.storeSettings == ""
                              ? "INR"
                              : this.context.storeSettings.defaultCurrency,
                        },
                      )}
                  </span>
                ) : null}
              </td>
              <td>
                {this.state.prod.productVariantType == 1 ? (
                  <Form.Control
                    type="decimal"
                    name="inStockQty"
                    size="lg"
                    value={this.state.prod.inStockQty}
                    required
                    min={0}
                    className="text-center text-danger fw-bold"
                    placeholder=""
                    autoComplete="off"
                    onChange={this.handleInputChange}
                    onKeyDown={(e) => this.handleVerticalFieldNavigation(e)}
                  />
                ) : null}
              </td>

              <td className="text-cener align-top">
                <div>
                  <OverlayTrigger overlay={<Tooltip>Save</Tooltip>}>
                    <Button
                      className="rounded-circle  bg-success m-0 p-1"
                      onClick={this.OnSave}
                    >
                      <BiSave size="20" />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                    <Button
                      className="rounded-circle    m-1 p-1"
                      variant="warning"
                      onClick={this.OnEditButtonClick}
                    >
                      <BsFillPencilFill size="20" />
                    </Button>
                  </OverlayTrigger>
                  <OverlayTrigger overlay={<Tooltip>Delete!</Tooltip>}>
                    <Button
                      className="mx-1 text-danger border-0 m-0 p-0"
                      style={{ backgroundColor: "transparent" }}
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure you want to Delete ?!",
                          confirmButtonText: "Yes, delete it!",
                          cancelButtonText: "No, cancel!",
                          showCancelButton: true,
                        }).then((result) => {
                          Swal.fire({
                            title: "Are you sure you want to Delete ?!",
                            confirmButtonText: "Yes, delete it!",
                            cancelButtonText: "No, cancel!",
                            showCancelButton: true,
                          }).then((result) => {
                            if (result.isConfirmed) this.OnDelete();
                          });
                        });
                      }}
                    >
                      <FaTrashAlt size={22} />
                    </Button>
                  </OverlayTrigger>
                </div>
              </td>
            </tr>
          </>
        ) : (
          <>
            <div className="border border-dark">
              <Table striped size="sm" className="">
                <tbody>
                  <tr
                    className="text-start text-dark bg-white mx-1"
                    style={{ fontSize: "12px" }}
                  >
                    <td className="text-start" colSpan={3}>
                      <Stack direction="horizontal" className="text-start">
                        <h3>{this.props.index + 1}. </h3>
                        {this.state.prod.productImages.length > 0 ? (
                          <img
                            src={
                              this.context.store.storageBlobUrl +
                              this.context.store.storageBlobContainerName +
                              "/images/" +
                              this.state.prod.productImages[0].fileName +
                              this.context.store.storageSasToken
                            }
                            className=" text-start"
                            alt="..."
                            style={{ height: "20px" }}
                          />
                        ) : null}
                        &nbsp;&nbsp;<h3>{this.state.prod.name}</h3>
                      </Stack>
                    </td>
                  </tr>
                  <tr
                    className="text-start align-top text-secondary bg-white mx-5"
                    style={{ fontSize: "12px" }}
                  >
                    <td colSpan={2} width={"70%"}>
                      <Stack direction="horizontal" gap={3}>
                        SKU
                        <Form.Control
                          type="text"
                          name="sku"
                          value={this.state.prod.sku}
                          required
                          placeholder="enter SKU"
                          min={0}
                          maxLength={20}
                          align="center"
                          className="text-center  "
                          autoComplete="off"
                          onChange={this.handleInputChange}
                        />
                        <Button
                          className="rounded-circle text-danger"
                          style={{ backgroundColor: "transparent" }}
                          onClick={this.OnScanner}
                        >
                          <IoMdQrScanner />
                        </Button>
                      </Stack>
                      {this.state.onscan ? (
                        <BarCodeScannerModal
                          barcode={this.GetBarCode}
                          Close={this.OnScannerClose}
                        />
                      ) : null}
                    </td>
                    <td
                      width={"30%"}
                      className="text-start"
                      style={{ verticalAlign: "top" }}
                    >
                      <tr>
                        <td
                          width="40% text-start"
                          style={{ verticalAlign: "middle" }}
                        >
                          ShowMe:
                        </td>
                        <td width="60%">
                          <Switch
                            height={20}
                            onChange={this.handleHidemeChange}
                            checked={!this.state.prod.hideMe}
                          />
                        </td>
                      </tr>
                    </td>
                  </tr>
                  <tr>
                    <td width={"40%"}>
                      {this.state.prod.productVariantType != 2 ? (
                        <>
                          <td style={{ verticalAlign: "middle" }}>MRP</td>
                          <td>
                            <Form.Control
                              type="number"
                              name="mrp"
                              value={this.state.prod.mrp}
                              required
                              placeholder=""
                              min={0}
                              align="center"
                              className="text-center  "
                              autoComplete="off"
                              onChange={this.handleInputChange}
                              onKeyDown={(e) =>
                                this.handleVerticalFieldNavigation(e)
                              }
                            />
                          </td>
                        </>
                      ) : null}
                    </td>
                    <td width={"40%"}>
                      {this.state.prod.productVariantType != 2 ? (
                        <>
                          <td style={{ verticalAlign: "middle" }}>Disc(%)</td>
                          <td>
                            <Form.Control
                              type="number"
                              name="discount"
                              value={this.state.prod.discount}
                              required
                              min={0}
                              className="text-center"
                              placeholder=""
                              autoComplete="off"
                              onChange={this.handleInputChange}
                              onKeyDown={(e) =>
                                this.handleVerticalFieldNavigation(e)
                              }
                            />
                          </td>
                        </>
                      ) : null}
                    </td>
                    <td width={"20%"}>
                      <Row>
                        <Col className="text-primary text-center align-middle">
                          <h1>
                            {this.context
                              .GetBasePrice(this.state.prod)
                              .toLocaleString(
                                this.context.storeSettings == ""
                                  ? "en-IN"
                                  : this.context.storeSettings.defaultLocale,
                                {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                  style: "currency",
                                  currency:
                                    this.context.storeSettings == ""
                                      ? "INR"
                                      : this.context.storeSettings
                                          .defaultCurrency,
                                },
                              )}
                          </h1>
                        </Col>
                      </Row>
                    </td>
                  </tr>
                  <tr>
                    {this.state.prod.productVariantType != 2 ? (
                      <>
                        <td colSpan={1} className="text-center" width={"60%"}>
                          <td style={{ verticalAlign: "middle" }}>InStk:</td>
                          <td>
                            <Form.Control
                              type="decimal"
                              name="inStockQty"
                              value={this.state.prod.inStockQty}
                              required
                              min={0}
                              className="text-center text-danger fw-bold"
                              placeholder=""
                              autoComplete="off"
                              onChange={this.handleInputChange}
                              onKeyDown={(e) =>
                                this.handleVerticalFieldNavigation(e)
                              }
                            />
                          </td>
                        </td>
                        <td className="text-center border" width={"20%"}>
                          <div>
                            <OverlayTrigger overlay={<Tooltip>Edit!</Tooltip>}>
                              <Button
                                className="rounded-circle  "
                                variant="warning"
                                style={{ backgroundColor: "transparent" }}
                                onClick={this.OnEditButtonClick}
                              >
                                <BsFillPencilFill size={16} />
                              </Button>
                            </OverlayTrigger>
                            &nbsp;
                            <OverlayTrigger
                              overlay={<Tooltip>Delete!</Tooltip>}
                            >
                              <Button
                                className="rounded-circle text-danger "
                                style={{ backgroundColor: "transparent" }}
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to Delete ?",
                                    )
                                  )
                                    this.OnDelete();
                                }}
                              >
                                <FaTrashAlt size={16} />
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                        <td className="text-center border" width={"20%"}>
                          <Col>
                            <OverlayTrigger overlay={<Tooltip>Save</Tooltip>}>
                              <Button
                                className=" w-100 CornersRounded"
                                variant="success"
                                onClick={this.OnSave}
                              >
                                <BiSave size="20" />
                                Save
                              </Button>
                            </OverlayTrigger>
                          </Col>
                        </td>
                      </>
                    ) : null}
                  </tr>
                </tbody>
              </Table>
            </div>
          </>
        )}
      </>
    );
  }
}

class BarCodeScannerModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={true}
          backdrop="static"
          keyboard={false}
          dialogClassName="BrandModal"
          onHide={this.props.Close}
        >
          <Modal.Header closeButton className="bg-warning">
            <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
          </Modal.Header>
          <Modal.Body className="show-grid ">
            <BarcodeScanner barcode={this.props.barcode}></BarcodeScanner>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export const BarcodeScanner = (props) => {
  const [result, setResult] = useState("");
  const { ref } = useZxing({
    onDecodeResult(result) {
      setResult(result.getText());
      props.barcode(result.getText());
    },
  });

  return (
    <>
      <video ref={ref} />
      <p>
        <span>Last result:</span>
        <span>{result}</span>
      </p>
    </>
  );
};
